/**
 * TopBar — sticky brand row (wordmark + Ask + theme toggle).
 *
 * "Site Office" restyle: uses the .topbar chrome class (sticky, blurred,
 * bordered) from global.css. Sits above the Ticker inside Shell's combined
 * sticky header (App.jsx). The "Ask" button opens the shared note sheet
 * (NoteSheetContext) — unchanged behavior, new chrome.
 */
import { MessageCircle, Settings as SettingsIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import ThemeToggle from './ThemeToggle.jsx';
import { useNoteSheet } from '../context/NoteSheetContext.jsx';

export default function TopBar() {
  const { open: openSheet } = useNoteSheet();
  const navigate = useNavigate();

  return (
    <div className="topbar">
      {/* Wordmark */}
      <span
        aria-label="Titan Client Console"
        className="d-xl"
        style={{
          fontSize:   '16px',
          color:      'var(--ink)',
          userSelect: 'none',
          whiteSpace: 'nowrap',
        }}
      >
        Titan <span style={{ color: 'var(--acc)' }}>Console</span>
      </span>

      {/* Right actions */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <button
          type="button"
          className="btnx quiet"
          aria-label="Ask a quick question"
          onClick={openSheet}
          style={{ height: '38px', fontSize: '11px', padding: '0 16px' }}
        >
          <MessageCircle size={14} strokeWidth={2} aria-hidden="true" />
          Ask
        </button>

        <ThemeToggle />

        {/* Account / settings — the only route to the logout control, which
            previously had no reachable home (Settings wasn't routed). */}
        <button
          type="button"
          aria-label="Account settings"
          onClick={() => navigate('/settings')}
          style={{
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            width: '38px', height: '38px', padding: 0,
            background: 'transparent', border: '1px solid var(--line-strong)',
            color: 'var(--ink-soft)', cursor: 'pointer',
          }}
        >
          <SettingsIcon size={16} strokeWidth={2} aria-hidden="true" />
        </button>
      </div>
    </div>
  );
}
